<ion-content>
    <ion-row class="h-100 flex-column ion-justify-content-center ion-align-items-center">
      <ng-lottie
        width="48px"
        height="48px"
        [options]="options" ></ng-lottie>
    </ion-row>
</ion-content>
